export default function () {
    const toTop = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }

    return { toTop }
}
